import type {
  DashboardChecklist,
  DashboardProducts,
  DashboardVisibility,
} from "@/types/dashboard";
import OnboardingHero from "./OnboardingHero";
import ShowcasePerformance from "./ShowcasePerformance";
import OnboardingProgress from "./OnboardingProgress";

type Props = {
  checklist?: DashboardChecklist;
  products?: DashboardProducts;
  visibility?: DashboardVisibility;
  statusDismissed?: boolean;
  statusClosing?: boolean;
  onDismissStatus?: () => void;
};

export default function OnboardingBanner({
  checklist,
  products,
  visibility,
  statusDismissed = false,
  statusClosing = false,
  onDismissStatus,
}: Props) {
  return (
    <section className="onboarding-banner w-full! min-w-0!">
      <div className="onboarding-banner-grid grid! gap-4!">
        <OnboardingHero
          profileComplete={checklist?.perfilCompleto}
          performanceRaised={statusDismissed}
        />
        <div
          key={statusDismissed ? "performance" : "status"}
          className={`onboarding-status-transition min-w-0! self-stretch! ${
            statusClosing ? "onboarding-status-closing" : ""
          }`}
        >
          {statusDismissed ? (
            <ShowcasePerformance visibility={visibility} />
          ) : (
            <OnboardingProgress
              checklist={checklist}
              products={products}
              onDismiss={onDismissStatus}
            />
          )}
        </div>
      </div>
    </section>
  );
}
